import styles from '../../style-bundles/lit-bundles/shared.scss?inline';
import { CSSResult, unsafeCSS } from 'lit';

export const sharedCss: CSSResult = unsafeCSS(styles);
